import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconMountainBike: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="mountain-bike"><path d="M19 15L16 4.75H13.75M6.75 6.75H9.75M10.9643 11.575L7.85714 7.25M16.6607 8.95L5 15" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square"/><circle cx="19" cy="15" r="4.25" stroke="currentColor" strokeWidth="1.5"/><circle cx="5" cy="15" r="4.25" stroke="currentColor" strokeWidth="1.5"/></CentralIconBase>;
};

export default IconMountainBike;
